import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'pollCountDown' })
export class PollCountDownPipe implements PipeTransform {
  transform(value: string): string {
    const converted = moment.utc(value).local();

    const sec = converted.diff(moment(), 'seconds');
    const mins = converted.diff(moment(), 'minutes');
    const hrs = converted.diff(moment(), 'hours');
    const days = converted.diff(moment(), 'days');

    let socialDate = '';

    if (sec < 15) {
      socialDate = 'Expired';
    } else {
      if (hrs < 1) {
        if (mins < 1) {
          socialDate = 'less than a minutes left';
        } else if (mins >= 1 && mins < 60) {
          socialDate = `${mins.toString()} minutes left`;
        } else {
          socialDate = `1hr, ${mins - 60} minutes left`;
        }
      } else if (hrs >= 1 && hrs <= 12) {
        socialDate = `${hrs} hours left`;
      } else {
        socialDate = `${hrs} hours left`;
      }
    }
    return socialDate;
  }
}
